import React from 'react';

export const LoginShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<div className="login-container">
			<div className="login-shell">
				<img src="/assets/images/login-logo" alt="Logo" />
				{children}
			</div>
		</div>
	);
};
